import { render, staticRenderFns } from "./cinema-info.vue?vue&type=template&id=4ab14616&scoped=true"
import script from "./cinema-info.vue?vue&type=script&lang=js"
export * from "./cinema-info.vue?vue&type=script&lang=js"
import style0 from "./cinema-info.vue?vue&type=style&index=0&id=4ab14616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab14616",
  null
  
)

export default component.exports